import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface SearchQueryResultStyles {
    searchTerm?: InjectableCss;
}

export const SearchQueryResultStyles: SearchQueryResultStyles = {
    searchTerm: {
        css: css`
            font-weight: 700;
            padding-left: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        padding-left: 0px;
                    `,
                ],
                "max",
            )}
        `,
    },
};

const StyledSpan = getStyledWrapper("span");

interface OwnProps {
    pageType?: string;
    extendedStyles?: SearchQueryResultStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    const pagination = getProductListDataViewProperty(state, "pagination");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;
    const homePageLink = getPageLinkByPageType(state, "HomePage");

    return {
        totalItemCount: pagination?.totalItemCount,
        query: correctedQuery || productFilters.query,
        homePageUrl: homePageLink?.url,
        searchWithinQuery: productFilters.searchWithinQueries ? productFilters.searchWithinQueries.join(" and ") : "",
    };
};

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;

const SearchQueryResult: FC<Props> = ({
    query,
    pageType,
    extendedStyles,
    searchWithinQuery,
}) => {

    const [styles] = useState(() => mergeToNew(SearchQueryResultStyles, extendedStyles));

    return (
        <StyledWrapper>
                {pageType === "NoSearchResultPage" ? (
                    <StyledSpan {...styles.searchTerm}>
                        {searchWithinQuery !== "" ? searchWithinQuery : query}
                    </StyledSpan>
                ) : (
                    ""
                )} 
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withHistory(SearchQueryResult));
